<template>
  <div>
    <date-and-location v-model="model.detail" :is-read-only="isReadOnly" />
    <skill v-model="model" :is-read-only="isReadOnly" />
  </div>
</template>

<script>
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';

import DateAndLocation from './components/DateAndLocation.vue';
import Skill from './components/Skill.vue';

export default {
  name: 'StructuredInterview',
  components: {
    DateAndLocation,
    Skill,
  },
  mixins: [storeMixin, alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
